"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function decodeHTMLEntities(text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}
exports.default = decodeHTMLEntities;
